const data = {
    0 : "Wrong user email or password!",
    1 : "A reset link has been sent to your email",
    2 : "Error while create stripe session proceeded",
    3 : "Profile image must be under 2MB and in JPG or PNG format",
    4 : "A verification link has been sent to your email",
    5 : 'Error while saving public url',
    6 : 'Please set payment amount',
    7 : "Payout successful",
    8 : "Copied to clipboard!",
    9 : "Please upload a profile photo",
    10 : "Error while save data",
    11 : "Error while updating data",
    12 : 'Email not found',
    13 : 'Error updating profile',
    14 : 'Email updated successfully!',
    'wechat_pay' : '此账户暂不支持微信支付',
    'alipay' : '此账户暂不支持支付宝支付',
};

const ToastMessage = (number) => {
    return(data && data[number]) || ''
};

export default ToastMessage
